if(window.navigator.userAgent.indexOf("Chrome-Lighthouse")==-1&&window.navigator.userAgent.indexOf("X11")==-1&&window.navigator.userAgent.indexOf("GTmetrix")==-1){var t=function(){if(!script_loaded){script_loaded=!0;var x=document.getElementsByTagName("script");for(i=0;i<x.length;i++)x[i].getAttribute("data-src")!==null&&(x[i].setAttribute("src",x[i].getAttribute("data-src")),delete x[i].dataset.src);var e=document.getElementsByTagName("link");for(i=0;i<e.length;i++)e[i].getAttribute("data-href")!==null&&(e[i].setAttribute("href",e[i].getAttribute("data-href")),delete e[i].dataset.href);document.dispatchEvent(new CustomEvent("StartKernelLoading")),setTimeout(function(){document.dispatchEvent(new CustomEvent("StartAsyncLoading"))},400)}},loadJSscripts=t,script_loaded=!1;window.addEventListener("scroll",function(x){t()}),window.addEventListener("mousemove",function(){t()}),window.addEventListener("touchstart",function(){t()}),window.addEventListener?window.addEventListener("load",function(){setTimeout(t,500)},!1):window.attachEvent?window.attachEvent("onload",function(){setTimeout(t,500)}):window.onload=t}
//# sourceMappingURL=/s/files/1/1100/5760/t/27/assets/custom.js.map?v=1627497511

var currentAccordion = null;
var headings = document.querySelectorAll('.accordion-item__button');

headings.forEach(function(heading) {
  heading.addEventListener('click', function() {
    if (currentAccordion && currentAccordion !== this) {
      currentAccordion.classList.remove('is-open');
      var currentContent = currentAccordion.nextElementSibling;
      currentContent.style.maxHeight = null;
    }
    // Toggle the clicked accordion
    this.classList.toggle('is-open');
    var content = this.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;  
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
    // Update the currently open accordion
    currentAccordion = (currentAccordion === this) ? null : this;
  });
});

